import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css';

const Footer = () => {
  return (
    <footer style={{ backgroundColor: '#f8f9fa', padding: '1rem 0', borderTop: '1px solid #dee2e6' }}>
      <Container>
        <Row className="justify-content-center align-items-center">
          <Col xs="auto">
            <a className="footer-icon-link" href="https://github.com/DavidJDallas" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.09 3.29 9.4 7.86 10.93.57.1.78-.25.78-.55 0-.27-.01-1.17-.02-2.12-3.2.7-3.88-1.36-3.88-1.36-.52-1.33-1.28-1.69-1.28-1.69-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.03 1.75 2.7 1.25 3.36.96.1-.75.4-1.25.73-1.54-2.56-.29-5.25-1.28-5.25-5.7 0-1.26.45-2.29 1.18-3.1-.12-.29-.51-1.46.11-3.04 0 0 .97-.31 3.18 1.18a11.05 11.05 0 0 1 5.79 0c2.2-1.49 3.17-1.18 3.17-1.18.63 1.58.24 2.75.12 3.04.74.81 1.18 1.84 1.18 3.1 0 4.43-2.7 5.41-5.27 5.69.42.36.78 1.07.78 2.15 0 1.55-.01 2.8-.01 3.18 0 .3.2.66.79.55A10.52 10.52 0 0 0 23.5 12C23.5 5.65 18.35.5 12 .5Z"/>
              </svg>
            </a>
          </Col>
          <Col xs="auto">
            <a className="footer-icon-link" href="mailto:daviddallas606@gmail.com" target="_blank" rel="noopener noreferrer" aria-label="Email">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
                <rect x="2" y="4" width="20" height="16" rx="2"/>
                <path d="m3 6 9 7 9-7"/>
              </svg>
            </a>
          </Col>
          <Col xs="auto">
            <a className="footer-icon-link" href="https://www.linkedin.com/in/david-dallas-925600253/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM2.5 9.5h5V21h-5V9.5Zm7.5 0h4.8v1.57h.07c.67-1.2 2.3-2.46 4.73-2.46 5.06 0 6 3.16 6 7.28V21h-5v-5.72c0-1.36-.03-3.12-2-3.12-2 0-2.31 1.5-2.31 3.02V21h-5V9.5Z"/>
              </svg>
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
